import { render, staticRenderFns } from "./SelectLayerTeacher.vue?vue&type=template&id=0bd4288a&scoped=true&"
import script from "./SelectLayerTeacher.vue?vue&type=script&lang=js&"
export * from "./SelectLayerTeacher.vue?vue&type=script&lang=js&"
import style0 from "./SelectLayerTeacher.vue?vue&type=style&index=0&id=0bd4288a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd4288a",
  null
  
)

export default component.exports